import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// 🛡️ Console Suppression for Production
// Suppress console output in production environments for security and performance
// COMMENTED OUT: Flutter dev needs to listen to console output
/*
if (!environment.enable_console_debug) {
    const originalConsole = { ...console };

    // Suppress debug/info logs in production
    console.log = () => {};
    console.info = () => {};
    console.warn = () => {};
    console.debug = () => {};
    console.group = () => {};
    console.groupEnd = () => {};
    console.table = () => {};

    // 🚨 Keep console.error for critical debugging in production
    console.error = originalConsole.error;
}
*/

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
